import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessConnection } from "@/shared/types/api/business-mode.types"

export const updateConnectionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessConnection"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      updateConnectionStatus: builder.mutation<BusinessConnection, { isEnabled: boolean }>({
        query: ({ isEnabled }) => ({
          url: `/api/v1/business/connections/status`,
          method: "PATCH",
          body: { is_enabled: isEnabled }
        }),
        invalidatesTags: () => [{ type: "BusinessConnection" as const }]
      })
    })
  })

export const { useUpdateConnectionStatusMutation } = updateConnectionApi
